import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { unsignedUploadDocumentReducer } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/reducers/unsigned-upload-document.reducer';
import { unsignedUploadDocumentStoreKey } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/store-config';
import { UnsignedUploadDocumentEffects } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/effects/unsigned-upload-document.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideUnsignedUploadDocumentStore = (): EnvironmentProviders[] => [
    provideState(unsignedUploadDocumentStoreKey, unsignedUploadDocumentReducer),
    provideEffects(UnsignedUploadDocumentEffects)
];
